import { render, staticRenderFns } from "./studentHour-detail.vue?vue&type=template&id=7009e661&scoped=true"
import script from "./studentHour-detail.vue?vue&type=script&lang=js"
export * from "./studentHour-detail.vue?vue&type=script&lang=js"
import style0 from "./studentHour-detail.vue?vue&type=style&index=0&id=7009e661&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7009e661",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7009e661')) {
      api.createRecord('7009e661', component.options)
    } else {
      api.reload('7009e661', component.options)
    }
    module.hot.accept("./studentHour-detail.vue?vue&type=template&id=7009e661&scoped=true", function () {
      api.rerender('7009e661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/studentHour-detail.vue"
export default component.exports